<template>
  <div
    :class="subgroup ? 'cf-node-properties__field-sub-group clearfix' : ''"
  >
    <template v-for="(param, index) in parameters">
      <div
        :key="index"
        class="cf-node-properties__field"
        :class="getFieldSize(param.name)"
      >
        <label class="control-label">
          <span style="white-space: pre-line;">{{ formatLongDisplayNames(param.displayName) }}</span> <span v-if="!param.isOptional">*</span>
          <i
            v-tooltip.top="param.description"
            class="fa fa-question-circle m-l-5"
            aria-hidden="true"
          />
        </label>

        <InputSelect
          v-if="param.type === 'list'"
          v-model="valueCopy[param.name]"
          :options="param.values"
          :placeholder="param.defaultValue"
          :required="!param.isOptional"
          :error="getFieldError(propertyErrors, `${parentParameterName}.${param.name}`)"
          @input="updateValue"
        />

        <InputNumber
          v-else-if="param.type === 'number'"
          v-model="valueCopy[param.name]"
          :required="!param.isOptional"
          :placeholder="param.defaultValue"
          :error="getFieldError(propertyErrors, `${parentParameterName}.${param.name}`)"
          @input="inputChange(param.name, $event)"
        />
        
        <InputText
          v-else-if="param.type === 'string' && !isParamCodeFormatted(param.name)"
          v-model="valueCopy[param.name]"
          :required="!param.isOptional"
          :placeholder="param.defaultValue"
          :error="getFieldError(propertyErrors, `${parentParameterName}.${param.name}`)"
          @input="inputChange(param.name, $event)"
        />

        <PrismEditor
          v-else-if="param.type === 'string' && isParamCodeFormatted(param.name)"
          v-model="valueCopy[param.name]"
          :highlight="highlighter"
          :line-mumbers="false"
          @input="inputChange"
        />

        <div
          v-else-if="param.type === 'sub_type'"
          class="cf-node-properties__input"
        >
          <nzToggle
            v-model="valueCopy[param.name].isEnabled"
            @input="updateValue"
          />
        </div>

        <div
          v-else-if="param.type === 'bool'"
          class="cf-node-properties__input"
        >
          <nzToggle
            v-model="valueCopy[param.name]"
            @input="updateValue"
          />
        </div>
      </div>



      <template
        v-if="
          param.type === 'sub_type' && valueCopy[param.name].isEnabled
        "
      >
        <SubTypeProps
          :key="`subType-${index}`"
          v-model="valueCopy[param.name]"
          :parameters="param.parameters"
          :property-errors="propertyErrors"
          @input="inputChange"
        />
      </template>
    </template>
  </div>
</template>

<script>
import {
  getFieldError,
  getFieldSize,
  codeFormattedFields
} from '../../../helpers/node';
import InputNumber from './Form/InputNumber';
import InputText from './Form/InputText';
import InputSelect from './Form/InputSelect';
import SubTypeProps from './SubTypeProps';
import nzToggle from '@/core/components/nzToggle/nzToggle';
import debounce from 'lodash/debounce';
import cloneDeep from 'lodash/cloneDeep';

// import Prism Editor
import { PrismEditor } from 'vue-prism-editor';

// import highlighting library (you can use any library you want just return html string)
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';

export default {
  name: 'SubTypeProps',
  components: {
    InputNumber,
    InputText,
    InputSelect,
    nzToggle,
    SubTypeProps,
    PrismEditor
  },

  props: {
    value: {
      type: Object,
      default: () => ({})
    },

    parameters: {
      type: Array,
      default: () => []
    },

    propertyErrors: {
      type: Array,
      default: () => []
    },

    parentParameterName: {
      type: String,
      default: ''
    },
    subgroup: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      valueCopy: {}
    };
  },

  watch: {
    value: {
      handler(newValue) {
        this.valueCopy = cloneDeep(newValue);
      },

      immediate: true
    }
  },

  methods: {
    getFieldError,

    getFieldSize,

    formatLongDisplayNames(name) {
      if (name === null || name === undefined) return '';
      if (name.length > 24) {
        const split = name.split(' ');
        if (split.length < 2) return name; // no spaces to split on
        split[split.length - 1] = '\n' + split[split.length - 1];
        return split.join(' ');
      }
      return name;
    },

    inputChange: debounce(function inputChange() {
      this.$emit('input', this.valueCopy);
    }, 500),

    updateValue() {
      this.$emit('input', this.valueCopy);
    },
    isParamCodeFormatted(paramName) {
      return codeFormattedFields.find(c => c === paramName);
    },
    highlighter(code) {
      return highlight(code, languages.js, 'js');
    }
  }
};
</script>
